var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.03,
    height: 21.36,
    viewBox: "0 0 24.03 21.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "house-solid",
    d: "M24.022,10.659A1.348,1.348,0,0,1,22.687,12H21.352l.029,6.679a3,3,0,0,1-.021.338v.676a1.668,1.668,0,0,1-1.669,1.669h-.668c-.046,0-.092-.038-.138,0-.058-.033-.117,0-.175,0H16.354a1.668,1.668,0,0,1-1.669-1.669V16.02a1.334,1.334,0,0,0-1.335-1.335H10.68A1.334,1.334,0,0,0,9.345,16.02v3.671A1.668,1.668,0,0,1,7.676,21.36H5.344c-.063,0-.125,0-.188-.008s-.1.008-.15.008H4.339A1.669,1.669,0,0,1,2.67,19.692V15.019c0-.038,0-.079,0-.117V12H1.337A1.322,1.322,0,0,1,0,10.659a1.355,1.355,0,0,1,.418-1L11.114.334A1.2,1.2,0,0,1,12.032,0a1.4,1.4,0,0,1,.88.293L23.563,9.658a1.133,1.133,0,0,1,.459,1Z",
    fill: "#23b574"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeLogo);
export default __webpack_public_path__ + "static/media/home-logo.fac956686629f8c5f5260be6bd1dc1c0.svg";
export { ForwardRef as ReactComponent };